import React from 'react';
import {useStyles} from "./style";
import * as animationDataUS from './animation_us.json';
import * as animationDataRU from './animation_ru.json';
import Lottie from "react-lottie-player";
import { getCurrentLang } from '../../locales/locales-utils';

export default () => {
    const classes = useStyles();
    const currentLang = getCurrentLang();

    return (
        <div className={classes.container}>
            <Lottie
                loop
                play
                animationData={currentLang == "en" ? animationDataUS : animationDataRU}
                style={{ width: currentLang == "en" ? 600 : 622, height: 600, transform: "translate(0, 0)" }}
                rendererSettings={{
                    preserveAspectRatio: 'xMidYMid slice'
                }}
            />
        </div>
    );
};
